import './Welcome.css'
import {Fragment} from "react";
import React from "react";
import {Link} from "react-router-dom";
import labImage from '../images/lab.jpg'; 
import meImage from '../images/Peter_Griffin.png'; // Assuming you have this based on your snippet

export const info={
    image: meImage, 
    title: "Hello, I'm Arya Taghizadeh.",
    description: "I am a Computer Engineering student at the University of Waterloo specializing in embedded systems, digital hardware design, and low-level firmware development. I am passionate about bridging the gap between hardware and software, with hands-on experience spanning bare-metal C/C++ drivers, FPGA architecture, custom PCBA design, and real-time operating systems.",
    
}

function Welcome() {
    return(
        <Fragment>
            <div id='whole-body'>
                
               
                <div 
                  className='welcome-hero-container'
                  style={{ 
                    backgroundImage: `linear-gradient(rgba(18, 18, 18, 0.75), rgba(18, 18, 18, 0.95)), url(${labImage})` 
                  }}
                >
                    <div className='hero-content-integrated'>
                        
                        {/* 1. Integrated Bio */}
                        <div className="merged-bio-area">
                            <img src={info.image} alt="Arya Taghizadeh" className="modern-bio-photo" />
                            <h2 className="merged-bio-title">{info.title}</h2>
                            <p className="modern-bio-text">{info.description}</p>
                            <p className="modern-bio-ending">{info.ending}</p>
                        </div>

                        {/* 2. Main Massive Name and Job Titles */}
                        <div className='hero-right-visuals'>
                            <div id="welcome-name-solid">
                                Hi, I'm Arya.
                            </div>

                            <div className='title-highlights-massive'>
                                <p className='desc-large'>
                                    I'm an <span id='firmware-modern'>Embedded</span>, <span id='hardware-modern'>Hardware</span>, and <span id="fpga-modern">FPGA</span> Developer.
                                </p>
                            </div>

                            {/* Restored Custom Button */}
                            <button className="about-me refined-btn">
                                <Link to='/projects'>
                                   <span className="circle" aria-hidden="true">
                                     <span className="icon arrow"></span>
                                   </span>
                                   <span className="button-text">My Projects</span>
                                </Link>
                            </button>
                        </div>

                    </div>
                </div>

                {/* Optional: if you have the SkillLogos component, place it here */}
                {/* <SkillLogos /> */}
                
            </div>
        </Fragment>
    )
}

export default React.memo(Welcome);